/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MeetdayMeetDayIdStudentIdTop5CompanyIdDelete$Params {

/**
 * MeetDay id
 */
  meetDayId: string;

/**
 * MeetDayStudent id
 */
  id: string;

/**
 * Company id
 */
  companyId: string;
}

export function meetdayMeetDayIdStudentIdTop5CompanyIdDelete(http: HttpClient, rootUrl: string, params: MeetdayMeetDayIdStudentIdTop5CompanyIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, meetdayMeetDayIdStudentIdTop5CompanyIdDelete.PATH, 'delete');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
    rb.path('id', params.id, {});
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

meetdayMeetDayIdStudentIdTop5CompanyIdDelete.PATH = '/meetday/{meetDayId}/student/{id}/top5/{companyId}';
